export default {
  error: {
    notInWhiteLit: 'You are not in the whitelist and have no right to use.',
  },
};
